export const isFailedFetchError = (error: unknown): boolean => {
  return (
    error instanceof TypeError &&
    error.name === 'TypeError' &&
    error.message === 'Failed to fetch'
  )
}

export const shouldWarnNetworkUnavailable = (
  error: unknown,
  online: boolean
): boolean => {
  return isFailedFetchError(error) && !online
}

export const hasResponseData = <T>(
  result: { data?: T | null } | null | undefined
): result is { data: T } => {
  return result != null && result.data != null
}
